'use client'

import { useIsActiveHideVatPrice } from '@/feature/product/hooks/useIsActiveHideVatPrice'
import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { Drawer, DrawerBody } from '@/ui/drawer/drawer/Drawer.client'
import { useAtom } from 'jotai'
import { displayProductPriceIncludedTaxDrawerAtom } from '../../services/product.store'

export function ProductPriceIncludedTaxDrawer(): React.ReactNode {
  const { t, Trans } = useTranslation(['productPriceIncludedTaxDrawer'])
  const [isDrawerOpen, setIsDrawerOpen] = useAtom(displayProductPriceIncludedTaxDrawerAtom)
  const isActiveHideVatPrice = useIsActiveHideVatPrice()

  if (isActiveHideVatPrice) {
    return null
  }

  return (
    <Drawer
      size="xl"
      isOpen={isDrawerOpen}
      onOpenChange={() => setIsDrawerOpen(false)}
      title={t('productPriceIncludedTaxDrawer:title')}
    >
      <DrawerBody>
        <div className="flex flex-col">
          <Trans i18nKey="productPriceIncludedTaxDrawer:description" />
        </div>
      </DrawerBody>
    </Drawer>
  )
}
